import React from 'react'

export function UiFilterContainer(props) {
    return (
        <>
            <div className='sb-filter-container mb-4' {...props} />
        </>
    )
}

export function UiFilterWr(props) {
    return (
        <>
            <div className='sb-filter-wr mt-4' {...props} />
        </>
    )
}

export function UiFilterTitle(props) {
    return (
        <>
            <h4 className='sb-filter-title  mt-4 mb-3'>
                {props.title}
            </h4>
        </>
    )
}

export function UiFilterSeeMore(props) {
    return (
        <>
            <div className='sb-filter-seemore mt-3 mb-3' onClick={props.action}>
                SeeMore
            </div>
        </>
    )
}
